import { useContext } from 'react';
import { TenantContext } from '../../contexts/TenantContext';

/**
 * 테넌트 컨텍스트 훅
 *
 * 멀티테넌트 AICC 환경에서 현재 활성 테넌트(보험사/금융사)를 관리.
 * GLOBAL_ADMIN은 테넌트를 전환하여 다른 조직의 데이터를 조회할 수 있으며,
 * 일반 사용자는 소속 테넌트로 자동 고정.
 *
 * @returns {{
 *   effectiveTenantId: string|null,
 *   selectedTenantId: string|null,
 *   selectTenant: (tenantId: string) => void,
 *   resetTenant: () => void,
 *   canSelectTenant: boolean,
 *   isOtherTenantSelected: boolean
 * }}
 *
 * @throws {Error} TenantProvider 외부에서 사용 시 오류 발생
 */
export function useTenant() {
  const context = useContext(TenantContext);

  if (!context) {
    throw new Error('useTenant must be used within a TenantProvider');
  }

  return context;
}

export default useTenant;
